import Swap from '../views/Swap'

const IndexPage = () => {
  return (
  // <Flex background="url('/images/swap-back.jpg') 50% / cover no-repeat #191919">
  <Swap />
  // </Flex>
  )
}

export default IndexPage
